module.exports = __webpack_public_path__ + "assets/Goods.168a6b82.svg";